import { ReactNode } from 'react';

import OrganisationUnit from '../../../../../domain/models/organisation-unit';
import ElectronicClientRecordProviderContext from './contexts/electronic-client-record-context';
import useElectronicClientRecordHook from './hooks/electronic-client-record-hook';

type Props = {
  children: ReactNode;
  selectedOrganisationUnit: OrganisationUnit | undefined;
  form: any;
  isLoading: boolean;
};

const ElectronicClientRecordProvider = ({ children, selectedOrganisationUnit, form, isLoading }: Props): React.JSX.Element => (
  <ElectronicClientRecordProviderContext value={useElectronicClientRecordHook({ selectedOrganisationUnit, form, isLoading })}>
    {children}
  </ElectronicClientRecordProviderContext>
);

export default ElectronicClientRecordProvider;
